var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white flex mdmax:flex-col"
  }, [_c('div', {
    staticClass: "p-6 flex-1 shadow-border-r mdmax:shadow-border-b"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Info User")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("ID")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.adminDetail.id))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.adminDetail.name))])]), _c('div', {
    staticClass: "flex items-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-56 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Email")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.adminDetail.email))])]), _c('div', {}, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Username")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.adminDetail.username))])])]), _c('div', {
    staticClass: "flex items-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-56 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Group")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.adminDetail.group))])]), _c('div', {}, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Jenis Kelamin")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.adminDetail.gender === 'M' ? 'Laki-laki' : 'Perempuan'))])])])]), _c('div', {
    staticClass: "p-6 flex-1 mdmax:flex-auto mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Role & Permission")]), _c('div', {
    staticClass: "flex items-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-56 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Role")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.adminDetail.role))])]), _c('div', {}, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Tipe Role")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.adminDetail.role_type))])])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Permission")]), _c('div', {
    staticClass: "border px-3 rounded-md"
  }, [_c('masonry', {
    attrs: {
      "cols": 2,
      "gutter": 30
    }
  }, _vm._l(_vm.permissionByGroup, function (permission, group) {
    return _c('div', {
      key: permission.id,
      staticClass: "py-2 block"
    }, [_c('p', {
      staticClass: "font-bold text-neutral-500 text-sm"
    }, [_vm._v(_vm._s(group))]), _vm._l(permission, function (item, index) {
      return _c('div', {
        key: 'item' + index,
        staticClass: "flex gap-6 justify-between items-center py-2 text-sm text-neutral-500"
      }, [_vm._v(" " + _vm._s(item.id) + " ")]);
    })], 2);
  }), 0)], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }